export const delay = (time: number) =>
  new Promise((resolve, _) => setTimeout(resolve, time))
